import {Controller} from "@hotwired/stimulus"
import {get} from "@rails/request.js";

// Connects to data-controller="acs--tenant"
export default class extends Controller {
    static values = {
        url: String,
    }
    static targets = ['tenant']

    connect() {
        if (this.tenantTarget.value) {
            this.tenantWarning()
        }
    }
    async tenantWarning() {
        const response = await this.tenantSearch(this.tenantTarget.value)
        if (response.ok) {
            let status = await response.json
            let el = document.getElementById("tenant_warning")
            if (el){
                if (status['status'] === 'true') {
                    this.displayBlock(el)
                }
                if (status['status'] === 'false') {
                    this.hiddenBlock(el)
                }
            }
        }
    }

    async tenantSearch(tenantValue) {
        return await get(`/admin/acs/tenant_documents/${tenantValue}/notification`, {
            responseKind: 'json'
        })
    }

    displayBlock(el) {
        el.classList.remove('d-none')
        el.classList.add('d-block')
    }

    hiddenBlock(el) {
        el.classList.remove('d-block')
        el.classList.add('d-none')
    }


}
